(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UploadDetailController', UploadDetailController);

    UploadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Upload', 'Agenzia', 'Campagna'];

    function UploadDetailController($scope, $rootScope, $stateParams, previousState, entity, Upload, Agenzia, Campagna) {
        var vm = this;

        vm.upload = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:uploadUpdate', function(event, result) {
            vm.upload = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
